// extracted by mini-css-extract-plugin
export var actions = "_vq-4";
export var item = "_vq-1";
export var price = "_vq-3";
export var quantity = "_vq-2";
export var table = "_vq-0";